interface IBook {
  jobs: string,
  jobsNosh: string,
  jobsBrewbound: string,
  jobsBevnet: string,

  postAJob: string,
  postAJobNosh: string,
  postAJobBrewbound: string,
  postAJobBevnet: string,
  editJob: (guid?: string) => string;
  editJobNosh: (guid?: string) => string;
  editJobBrewbound: (guid?: string) => string;
  upgradeJob: (quid?: string) => string;
  upgradeJobNosh: (quid?: string) => string;
  upgradeJobBrewbound: (quid?: string) => string;
  copyListing: (quid?: string) => string;
  copyListingNosh: (quid?: string) => string;
  copyListingBrewbound: (quid?: string) => string;
  reactivateListing: string;
  reactivateListingNosh: string;
  reactivateListingBrewbound: string;
  postPrepaidListing: (quid?: string) => string;
  postPrepaidListingNosh: (quid?: string) => string;
  postPrepaidListingBrewbound: (quid?: string) => string;
  noremaining: string;
  prepaidListingExpired: string;
  receipt: string;
  receiptNosh: string;
  receiptBrewbound: string;
  jobsAccount: string;
  jobsEmployer: string;
  jobsJobSeeker: string;
  myApplications: string;
  savedJobs: string;
  myResume: string;
  jobsListings: string;
  jobsAllApplicants: string;
  jobsNewApplicants: string;
  jobsPrepaid: string;
  resumeDatabase: string;
  resumeDatabaseDetail: (rguid?: string) => string;
  resumeContact: (requestGuid?: string) => string;
  jobsPrepaidDetail: (guid?: string) => string;
  jobsApplicants: (guid?: string) => string;
  jobsApplicantDetail: (eguid?: string, applicationId?: string | number) => string;
}

export const book: IBook = Object.freeze({
  jobs: '/PrepaidPurchase',
  jobsNosh: '/PrepaidPurchase/nosh',
  jobsBrewbound: '/PrepaidPurchase/brewbound',
  jobsBevnet: '/PrepaidPurchase/bevnet',

  postAJob: '/PostJobListing',
  postAJobBrewbound: '/PostJobListing/brewbound',
  postAJobNosh: '/PostJobListing/nosh',
  postAJobBevnet: '/PostJobListing/bevnet',
  editJob: (guid?: string) => (
    guid ? `/jobs/EditJob/${encodeURIComponent(guid)}` : '/jobs/EditJob/:guid'
  ),
  editJobBrewbound: (guid?: string) => (
    guid
      ? `/jobs/EditJob/brewbound/${encodeURIComponent(guid)}`
      : '/jobs/EditJob/brewbound/:guid'
  ),
  editJobNosh: (guid?: string) => (
    guid
      ? `/jobs/EditJob/nosh/${encodeURIComponent(guid)}`
      : '/jobs/EditJob/nosh/:guid'
  ),
  reactivateListing: '/jobs/reactivatelisting',
  reactivateListingBrewbound: '/jobs/reactivatelisting/brewbound',
  reactivateListingNosh: '/jobs/reactivatelisting/nosh',
  upgradeJob: (guid : string) => {
    if (guid) {
      return `/jobs/upgradelisting/${guid}`;
    }
    return '/jobs/upgradelisting/:guid';
  },
  upgradeJobBrewbound: (guid : string) => {
    if (guid) {
      return `/jobs/upgradelisting/brewbound/${guid}`;
    }
    return '/jobs/upgradelisting/brewbound/:guid';
  },
  upgradeJobNosh: (guid : string) => {
    if (guid) {
      return `/jobs/upgradelisting/nosh/${guid}`;
    }
    return '/jobs/upgradelisting/nosh/:guid';
  },
  copyListing: (guid : string) => {
    if (guid) {
      return `/jobs/CopyListing/${guid}`;
    }
    return '/jobs/CopyListing/:guid';
  },
  copyListingBrewbound: (guid : string) => {
    if (guid) {
      return `/jobs/CopyListing/brewbound/${guid}`;
    }
    return '/jobs/CopyListing/brewbound/:guid';
  },
  copyListingNosh: (guid : string) => {
    if (guid) {
      return `/jobs/CopyListing/nosh/${guid}`;
    }
    return '/jobs/CopyListing/nosh/:guid';
  },
  postPrepaidListing: (guid : string) => {
    if (guid) {
      return `/jobs/postprepaidlisting/${guid}`;
    }
    return '/jobs/postprepaidlisting/:guid';
  },
  postPrepaidListingBrewbound: (guid : string) => {
    if (guid) {
      return `/jobs/postprepaidlisting/brewbound/${guid}`;
    }
    return '/jobs/postprepaidlisting/brewbound/:guid';
  },
  postPrepaidListingNosh: (guid : string) => {
    if (guid) {
      return `/jobs/postprepaidlisting/nosh/${guid}`;
    }
    return '/jobs/postprepaidlisting/nosh/:guid';
  },
  noremaining: '/jobs/noremaining',
  prepaidListingExpired: '/jobs/prepaidlistingexpired',
  receipt: '/jobs/receipt',
  receiptBrewbound: '/jobs/receipt/brewbound',
  receiptNosh: '/jobs/receipt/nosh',
  jobsAccount: '/user',
  jobsEmployer: '/user/employer',
  jobsJobSeeker: '/user/job-seeker',
  myApplications: '/user/job-seeker/applications',
  savedJobs: '/user/job-seeker/saved',
  myResume: '/user/job-seeker/resume',
  jobsListings: '/user/employer/listings',
  jobsAllApplicants: '/user/employer/applicants',
  jobsNewApplicants: '/user/employer/applicants/new',
  jobsPrepaid: '/user/employer/packages',
  resumeDatabase: '/user/employer/resumes',
  resumeDatabaseDetail: (rguid?: string) => (
    rguid ? `/user/employer/resumes/${rguid}` : '/user/employer/resumes/:rguid'
  ),
  resumeContact: (requestGuid?: string) => (
    requestGuid ? `/resume-contact/${requestGuid}` : '/resume-contact/:requestGuid'
  ),
  jobsPrepaidDetail: (guid?: string) => (
    guid ? `/user/employer/packages/${guid}` : '/user/employer/packages/:id'
  ),
  jobsApplicants: (guid?: string) => (
    guid
      ? `/user/employer/listings/${guid}/applicants`
      : '/user/employer/listings/:guid/applicants'
  ),
  jobsApplicantDetail: (eguid?: string, applicationId?: string | number) => (
    eguid && applicationId
      ? `/user/employer/listings/${eguid}/applicants/${applicationId}`
      : '/user/employer/listings/:eguid/applicants/:applicationId'
  )
});
